module.exports = __webpack_public_path__ + "static/media/1 17 gjerne.317b0aa2.mp3";